import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { SubjectSelected } from '../shared/subject-selected.model';
import { MatTableDataSource, MatDialog, MatDialogConfig } from '@angular/material';
import { RequestDetailEvaluator } from '../shared/request-detail-evaluator.model';
import { SelectSubjectRequestDialogComponent } from '../../../core/modal/select-subject-request-dialog/select-subject-request-dialog.component';


import { Matter } from '../../requets/shared/matter.model';
import { UtilityService } from '../../../core/shared/utility.service';
import { Score } from '../../programs/shared/score.model';
import { ParametersProgram } from '../../programs/shared/parameters-program.model';
import { ProgramService } from '../../programs/shared/program.service';
import { from } from 'rxjs';
import { log } from 'util';



@Component({
  selector: 'app-subject-evaluate-selected',
  templateUrl: './subject-evaluate-selected.component.html',
  styleUrls: ['./subject-evaluate-selected.component.scss']
})
export class SubjectEvaluateSelectedComponent implements OnInit, OnChanges {

  displayedColumns: string[] = ['codigo', 'materia', 'banco', 'periodo',  'nota', 'creditos', 'comentario', 'action'];
  subjects: SubjectSelected[] = [];
  periods: String[];
  cuanti: Score[] = [];
  cuanli: Score[] = [];
  dataSource: MatTableDataSource<SubjectSelected>;
  messageError: String = '';
  @Input() parameters: ParametersProgram;
  @Input() finalScore: String;
  @Input() credit: number;
  @Input() subjectSelected:  RequestDetailEvaluator[];
  @Input() program;
  @Input() version;
  @Input() isCualitative;
  itemCredito: number;
  itemNota: number;



  constructor(private dialog: MatDialog,
              private programService: ProgramService,
              private utilityService: UtilityService) { }

  ngOnInit() {
    this.periods = this.utilityService.generatePeriod();

  }
  ngOnChanges() {
    this.geOptionNote();
  }

  deleteSubject(item) {
    this.subjects.splice(item, 1);
    this.dataSource = new MatTableDataSource(this.subjects);
  }

  geOptionNote() {
      if (this.parameters) {

        for (let i = 50; i >= this.parameters.notaMinima * 10; i--) {
          const notaItem = new Score();
          notaItem.label = (i / 10) + '' ;
          this.cuanti.push(notaItem);

        }

      }


  }

  searchSubject() {


console.log('subjectSelected', this.subjectSelected);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '70%';
    dialogConfig.data = {
      program: this.program,
      version: this.version,
      cualitative: this.isCualitative,
    };
    const dialogRef = this.dialog.open(SelectSubjectRequestDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result !== null) {
          const subject = result.item as Matter;
          this.messageError = '';
          if (!this.subjects[subject.codigo]) {
            const subjectSelected = new SubjectSelected();
            subjectSelected.codigo = subject.codigo;
            subjectSelected.nombre = subject.nombre;
            subjectSelected.consecutivo = subject.consecutivo;
            subjectSelected.banco = subject.banco;
            // subjectSelected.cualitativa =  subject.cualitativa;
            subjectSelected.tipo = subject.tipo;
            subjectSelected.cualitativa = this.getTipo(subject.tipo);
            subjectSelected.creditos = subject.creditos;
            // subjectSelected.nota = this.getScore(subjectSelected.cualitativa);
            subjectSelected.nota = this.getScore(subjectSelected.tipo);
            //subjectSelected.periodo = this.utilityService.getNextPeriodoAvaible();
            subjectSelected.periodo = this.subjectSelected[0].semestre.toString();
            console.log('subjectSelected; ', this.subjectSelected[0].semestre.toString());
            this.subjects.push(subjectSelected);
            this.dataSource = new MatTableDataSource(this.subjects);
          } else {
            this.messageError = 'La materia ya ha sido seleccionada!';
          }

        }
      }
    );

  }

 getCredit(credito) {
   let result;
  if (this.subjectSelected) {
    if (this.subjectSelected.length === 1) {
        result = credito;
    }
  }
  return result;
 }

  getScore(cualitative): String {
    let result: String;
    if (this.isCualitative) {
      if (cualitative === 'Cualitativa') {
        result = 'Aprobado';
      } else {
        this.finalScore = '3';
        if (Number(this.finalScore) % 1 === 0) {
          result = this.finalScore;
        } else {
          result = Number(this.finalScore).toFixed(1);
        }
      }
    } else {
      if (cualitative === 'Cualitativa') {
        result = 'Aprobado';
      } else {
        if (Number(this.finalScore) % 1 === 0) {
          result = this.finalScore + '';
        } else {
          result = Number(this.finalScore).toFixed(1);
        }
      }
    }
    return result;
  }

  getTipo(tipo): boolean {
    let result: boolean;
    if (tipo === 'Cualitativa') {
      result = true;
    } else {
      result = false;
    }
    return result;
  }

  validateChangeCredit(item: SubjectSelected) {
    let result;
    if (item) {
      this.itemCredito = Number(item.creditos);
      result = this.itemCredito !==  this.credit;
    }
    return result;
  }

  validateChangeScore(nota) {
    let validate;
    this.itemNota = Number(nota);
    if (Number(this.finalScore) % 1 === 0) {
      validate = this.itemNota !== Number(this.finalScore);
    } else {
      validate = nota !== Number(this.finalScore).toFixed(1);
    }
    return  validate;
  }

  validateDeleteSubject(): boolean {
    let validate = false;
    if (this.subjectSelected) {
      if (this.subjectSelected.length > 1) {
        if (this.subjects.length === 1) {
          validate =  false;
        }
      }
    }
    return validate;
  }

  validateSubjects(): boolean {
    let validate = false;
    if (this.subjectSelected) {
      if (this.subjectSelected.length > 1) {
        if (this.subjects.length === 1) {
          validate =  true;
        }
      }
    }
    return validate;
  }


}
